import { jsx as e } from "react/jsx-runtime";

import { forwardRef as n } from "react";

import o from "../Input/index.js";

import r from "./hooks/useMaskedInput/index.js";

const a = n((({mask: n, dynamic: a, transform: t, onChange: m, onKeyDown: s, value: u, defaultValue: f, ...i}, d) => {
    const l = r({
        mask: n,
        dynamic: a,
        transform: t,
        value: u ?? f,
        onChange: m,
        onKeyDown: s
    });
    return e(o, {
        ...i,
        ...l.events,
        value: l.transformedValue,
        ref: d
    });
}));

export { a as default };
//# sourceMappingURL=index.js.map
